import React from 'react';
import { observer } from 'mobx-react-lite';
import { PopupStackTemplate } from './PopupStackTemplate';
import { useCommon } from 'src/AppState/Common';
import { PopupsStackState } from 'src/AppState/PopupsStackState';

export const PopupsStack = observer(() => {
    const common = useCommon();
    const popupsStack = PopupsStackState.get(common);

    return popupsStack.topPopup !== undefined && <PopupStackTemplate popup={popupsStack.topPopup} />;
});
